import { Button, styled } from '@mui/material';
import { Theme } from '@mui/material/styles';

export const GradientButton = styled(Button)(({ theme }: { theme: Theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
  borderRadius: theme.shape.borderRadius,
  padding: '10px 24px',
  color: theme.palette.common.white,
  fontWeight: 600,
  textTransform: 'none',
  fontSize: '0.95rem',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    background: `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
    transform: 'translateY(-1px)',
    boxShadow: `0 4px 12px ${theme.customPalette.glow.primary}`,
  },
  '&:disabled': {
    background: `linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.primary.light} 100%)`,
    opacity: 0.7,
  },
}));

export default GradientButton;
